<div class="header-span__choose_item" *ngIf="selectTargetMode===true" [class.selected]="selectedContract?.guid">
  <span style="color: black;" >{{selectedContract?.guid? 'Выбран контракт:' : 'Выберите субконтракт:'}}</span>
  <span>{{selectedContract?.guid? selectedContract.name : 'Субконтракт не выбран'}}</span>
</div>
<span class="header-span" *ngIf="widgetView!==true">
    <div class="header-span-left-block">
    <mat-form-field class="header-span__filter">
        <mat-label> {{ 'BUTTON_TEXT.SEARCH'|translate }}</mat-label>
        <input [formControl]="textFilterInput"
                [matTooltip]="'TASKS.TOOLTIPS.USE_CONTEXT_MENU' | translate" matInput
                type="text">
        <button [matTooltip]="'CONTRACTS.BUTTONS.CLEAR'|translate" data-action="clearFilter" mat-icon-button      matSuffix> 
            <mat-icon (click)="textFilterClear()">close</mat-icon> 
        </button>
    </mat-form-field>
    </div>

    <div class="header-span__paginator" [class.minimized]="selectTargetMode">
    <button (click)="submitSelectedTarget()" *ngIf="selectTargetMode===true"  
        [disabled]="!selectedContract"
        data-action="submitSelectedTarget"
        class="button-icon size-xl primary-button">
        {{ 'Выбрать' | translate }}
        <mat-icon svgIcon="file-copy-2-fill"> </mat-icon>
    </button>
    <button (click)="openDialog(createContractView, 700)" data-action="openCreateContract"  class="button-icon size-xl outline-button">
        {{ 'CONTRACTS.BUTTONS.CREATE' | translate }}    
        <mat-icon svgIcon="contract-line"> </mat-icon>
        </button>
        
        <ng-container *ngIf="selectTargetMode===false">
        <button (click)="exportToExcel()" data-action="exportToExcel"
            class="button-icon icononly size-xl outline-button" 
            [matTooltip]="'BUTTON_TEXT.TOOLTIPS.EXCEL_EXPORT'| translate " >
            <mat-icon class="header-span__action-button__icon" matSuffix>save_alt</mat-icon>
        </button>
        
        <button (click)="submitQuery(true,true)"  data-action="submitQuery"
            class="button-icon icononly size-xl outline-button"
            [matTooltip]="'BUTTON_TEXT.RELOAD_DATA'| translate "   >
            <mat-icon class="header-span__action-button__icon" matSuffix>refresh</mat-icon>
        </button>
        <button (click)="openUISettings()"  data-action="openUISettings"
            class="button-icon icononly size-xl outline-button"
            [matTooltip]="'BUTTON_TEXT.SETTINGS_TABLE'| translate "   >
            <mat-icon class="header-span__action-button__icon" matSuffix>settings</mat-icon>
        </button>
        <mat-paginator #intlPaginator  style="visibility: hidden;width: 1px;"></mat-paginator>
    </ng-container>
    <div class="">
        <mat-paginator #uiPaginator  disabled="{{uiPaginatorOff === true || this.textFilterInput.value !==''}}"
        (page)="onPageChange($event)" 
        [hidePageSize]="selectTargetMode===true"> 
    </mat-paginator>
        <div class="loading-info">
            Загружено {{(dataSource?.data?.length||0)}} из {{(matPaginator?.length||0)}} контрактов 
        </div>
    </div>
    </div>
</span>

<mat-expansion-panel  *ngIf="widgetView!==true" (closed)="panelOpenState = false" (opened)="panelOpenState = true" [expanded]="false">
    <mat-expansion-panel-header>
        <mat-panel-title> {{ 'LABELS.CUSTOM_FILTER'| translate }}</mat-panel-title>
        <mat-panel-description>
            {{ 'LABELS.EXPAPANSION_PANEL.' + (panelOpenState ? 'CLOSE' : 'OPEN')| translate }}
            <mat-icon style="margin-left: 1vw;">filter_alt</mat-icon>
        </mat-panel-description>
    </mat-expansion-panel-header>
    <form [formGroup]="searchForm" class="complex-search">
        <span class="complex-search_buttons">
          <button (click)="submitQuery()" [disabled]="!this.searchForm.dirty" class="complex-search_buttons_search"
                  data-action="submitQuery"
                  mat-flat-button>
                     {{ 'BUTTON_TEXT.FIND'| translate }}
                    </button>
          <button (click)="searchForm.reset();   dataRange.reset();" class="complex-search_buttons_clear"
                  data-action="searchForm.reset"
                  mat-flat-button>
            {{ 'BUTTON_TEXT.CLEAR'| translate }}
          </button>
        </span>
        <mat-form-field appearance="fill" class="complex-search_date-range" >
            <mat-label>{{ 'LABELS.DATE_RANGE_INPUT'| translate }}</mat-label>
            <mat-date-range-input [formGroup]="dataRange" [rangePicker]="picker" disabled="true">
                <input [placeholder]="'LABELS.DATE_RANGE.START'| translate" formControlName="dateRangeStart"
                       matStartDate>
                <input [placeholder]="'LABELS.DATE_RANGE.END'| translate" formControlName="dateRangeEnd" matEndDate>
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error
                    *ngIf="dataRange.controls.dateRangeStart.hasError('matDatepickerParse')">{{ 'VALIDATION.DATE_RANGE.START'| translate }}
            </mat-error>
            <mat-error
                    *ngIf="dataRange.controls.dateRangeEnd.hasError('matDatepickerParse')">{{ 'VALIDATION.DATE_RANGE.END'| translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="complex-search_amount"
                        matTooltip="Введите диапазон в формате Min - Max значения">
            <input formControlName="amountRange" matInput placeholder="Сумма или (Min - Max)">
            <mat-hint *ngIf="amountRange.valid">
                Сумма или Min-Max
            </mat-hint>
            <mat-error *ngIf="amountRange?.errors?.['incorrectRange']">
                Неверный диапазон
            </mat-error>
        </mat-form-field>
        <mat-form-field class="complex-search_states">
            <mat-label>{{ 'CONTRACTS.TEXT.CONTRACT_STATE'| translate }}</mat-label>
            <mat-select formControlName="contractStatuses" multiple >
                <mat-option (click)="status==='all_statuses'? searchFormStatesToggleAll($event):null"
                            *ngFor="let status of contractStatusesArr"
                            [value]="status"
                > {{ 'CONTRACTS.STATUSES.' + status|translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</mat-expansion-panel>
<div class="table-responsive">
    <table (cdkDropListDropped)="tableDropColumn($event)" *ngIf="dataSource" [dataSource]="dataSource" cdkDropList
           cdkDropListOrientation="horizontal"
           mat-table matSort multiTemplateDataRows>
        <ng-container *ngFor="let column of columnsToDisplay ; let i=index" [matColumnDef]="column">
            <th *matHeaderCellDef cdkDrag class="contract-table_header-cell" mat-header-cell
                mat-sort-header> {{ customPropModels.get(column)?.title || 'CONTRACTS.TITLES.' + columnsToDisplay[i] | translate }}
            </th>
            <td *matCellDef="let element" [cdkContextMenuTriggerFor]="contextmenu" class="contract-table_row-cell"
                mat-cell>
        <span [ngSwitch]="true==true">
            <p *ngSwitchCase="column==='description_text'"
               (click)="openContentDialog(element.description)"
               [matTooltip]="'CONTRACTS.TOOLTIPS.VIEW_DESCRIPTION' | translate"
               style="white-space: nowrap;   overflow: hidden;   text-overflow: ellipsis;   width: 150px !important; cursor: pointer;">
              {{ element[column] }}
            </p>
            <p *ngSwitchCase="column==='creator_guid'">
                <a [routerLink]="" [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_PROFILE' | translate"
                   (click)="openMember(element[column])">
                   <span class="link" style="margin-right: 5px;"> 
                    {{ element[column] }} 
                  </span>
                </a> 
            </p>
          <p *ngSwitchCase="column==='updated_at'">{{ element[column] | date:'dd/MM/yy, HH:mm:ss' }}   </p>
          <p *ngSwitchCase="column==='created_at'">{{ element[column] | date:'dd/MM/yy, HH:mm:ss' }}  </p>
          <p *ngSwitchCase="column==='master_project.type' && !!element[column] ">{{ ('PROJECT.TYPE.' + element[column]) | translate }}  </p>
          <p *ngSwitchCase="column==='master_project.subtype' && !!element[column] ">{{ 'PROJECT.SUBTYPE.' + element[column] | translate }}  </p>
          <p *ngSwitchCase="column==='status'">
            <button style="cursor: default;"
                    [class]="'contract-table_row-cell_status ' + element[column] "
                    mat-raised-button>
              {{ 'CONTRACTS.STATUSES.' + element[column] | translate }} 
            </button>
          <p *ngSwitchCase="column==='name'">
            <button (click)="showContractForm(element)" [matTooltip]="'CONTRACTS.TOOLTIPS.OPEN_CONTRACT' | translate"
                    [class]="'contract-table_row-cell_name ' + (element[column]?.length>50? 'long-text' : '') " 
                    
                    mat-raised-button
            >
              <span class="contract-table_row-cell_name">
                {{ element[column] }}
              </span> 
            </button> 
          </p>
          <p *ngSwitchCase="['contracts'].includes(column)">
            <button *ngFor="let contract of element[column]" mat-raised-button
                    (click)="showContractDialog(contract.guid?.guid||contract.guid)"
                    [class]="'contract-table_row-cell_contracts'"
                    [matTooltip]="'TASKS.TOOLTIPS.VIEW_CONTRACT' | translate" data-action="showContractDialog">

              {{ 'CONTRACTS.TITLES.' + contract.type |translate }}
            </button> 
          </p>
          <p *ngSwitchCase="column.split('.')[0]==='custom_properties'">
            <span [ngSwitch]="true===true">
            <p *ngSwitchCase="customPropModels.get(column).property_type==='property_file' && customPropModels.get(column).is_multiform ">
                <a *ngFor="let member of element[column]" [routerLink]=""
                   [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_FILE' | translate"
                   (click)="openFile(member.key)">
                   <span class="link" style="margin-right: 5px;"> {{ member?.name }} </span>
                </a> 
            </p>
            <p *ngSwitchCase="customPropModels.get(column).property_type==='property_file' && customPropModels.get(column).is_multiform==false">
                <a [routerLink]="" [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_FILE' | translate"
                   (click)="openFile(element[column]?.key)">
                   <span class="link" style="margin-right: 5px;">{{ element[column]?.name }} </span>
                </a> 
            </p>
            
            <p *ngSwitchCase="customPropModels.get(column).property_type==='property_member'&&customPropModels.get(column).is_multiform ">
                <a *ngFor="let member of element[column]" [routerLink]=""
                   [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_PROFILE' | translate"
                   (click)="openMember(member.guid)">
                   <span class="link" style="margin-right: 5px;"> {{ member?.lastname }} </span>
                </a> 
            </p>
            <p *ngSwitchCase="customPropModels.get(column).property_type==='property_member' && customPropModels.get(column).is_multiform==false ">
                <a [routerLink]="" [matTooltip]="'PROPERTIES.TOOLTIPS.VIEW_PROFILE' | translate"
                   (click)="openMember(element[column].guid)">
                   <span class="link" style="margin-right: 5px;"> 
                    {{ element[column]?.lastname }} 
                  </span>
                </a> 
            </p>
            <p *ngSwitchCase="customPropModels.get(column).property_type==='property_boolean' ">
                 <mat-checkbox class="checkbox" [(ngModel)]="element[column]"
                               (click)="$event.preventDefault(); element[column]=element[column]"></mat-checkbox>
            </p>
            <p *ngSwitchCase="customPropModels.get(column).property_type==='property_text'"
               (click)="openContentDialog(element[column])"
               [matTooltip]="'CONTRACTS.TOOLTIPS.VIEW_DESCRIPTION' | translate"
               style="white-space: nowrap;   overflow: hidden;   text-overflow: ellipsis;   width: 150px !important; cursor: pointer;">
                {{ element[column] }}
            </p>
            <p *ngSwitchDefault>
                {{ element[column] }}
            </p>
            </span>
        </p>
          <p *ngSwitchDefault>
            {{ element[column] }}
          </p>
          <ng-template #contextmenu>
          <div cdkMenu class="menu-context">
              <button
                      (click)="textFilterUpdate(element[column])"
                      cdkMenuItem class="menu-context-item">
                <mat-icon class="menu-icon" matPrefix>filter_list</mat-icon>
                  {{ 'CONTEXT_MENU.FILTER' | translate }}..
              </button> 
              <button (click)="textFilterClear()" cdkMenuItem
                      class="menu-context-item" data-action="textFilterClear">
              <mat-icon class="menu-icon" matPrefix>close</mat-icon>
                  {{ 'CONTEXT_MENU.CLEAR_FILTER' | translate }}..
              </button> 
              <button
                      (click)="openCreateContract(element)"
                      cdkMenuItem class="menu-context-item">
                <mat-icon class="menu-icon" matPrefix>add_circle</mat-icon>
                  {{ 'CONTEXT_MENU.CREATE' | translate }}..
              </button>
            <button
                    (click)="showContractForm(element)"
                    cdkMenuItem class="menu-context-item">
              <mat-icon class="menu-icon" matPrefix>edit</mat-icon>
                {{ 'CONTEXT_MENU.EDIT' | translate }}..
            </button> 
          </div>
        </ng-template> 
        </span>
            </td>
        </ng-container>
        <tr *matHeaderRowDef="columnsToDisplay; sticky: true" class="contract-table_header"  [class.widget-header]="widgetView" mat-header-row></tr>
        <tr *matRowDef="let element; columns: columnsToDisplay;let dataindex=dataIndex;" class="contract-table_row"  mat-row       tabindex=0
          (click)="selectContract(element)"
          [class.selected]="selectedContract?.guid && selectedContract?.guid===element?.guid"
          ></tr>
    </table>
    <div *ngIf="noContractsInDB" class="no-contracts">{{'EMPTY_LISTS.CONTRACTS' | translate}}</div>
</div>


<ng-template #createContractView let-modal>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.CONTRACT' | translate }}</h2>
        <h3>{{ 'MODALS.FIELDS.TITLE' | translate }}</h3>
        <input #contractName
               aria-describedby="emailHelp"
               class="form-control"
               required>

        <h2 class="mt-3">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <div class="task__content mb-3">
            <app-component-ckeditor
                    (emitFinish)="description = $event[1]"
                    [isShowButtons]="false">
            </app-component-ckeditor>
        </div>
        <button (click)="createContracts(contractName, modal)"
                [disabled]="isLockButton"
                class="button-icon size-xl primary-button" style="margin-top: 12px; margin-bottom: 12px;"
                data-action="createContract">
                <mat-icon svgIcon="checkbox-fill"></mat-icon>
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
<!--         <button class="button-icon size-l primary-button" data-action="addSigner" style="margin-top: 12px; margin-bottom: 12px;"
        [disabled]="fileModel.is_approved"
        (click)="openDialog(addSignersView,500,200)">
        <span>  {{ 'MODALS.BUTTONS.CREATE'| translate }}   </span>
        </button> -->
    </div>
</ng-template>
